import OrganizationType from './typelist/OrganizationType';
import CityType from './typelist/CityType';
import StateType from './typelist/StateType';
import StatusType from './typelist/StatusType';
import OrgSubType from './typelist/OrgSubType';
import FirebaseUtil from './FirebaseUtil';
import { COLLECTION_ROLES, COLLECTION_USERS } from './AppConstants';
import Member from './Member';

export default class Organization {
    name: string;

    type?: OrganizationType;

    state?: StateType;

    city?: CityType;

    status?: StatusType;

    createdTime: Date = new Date();

    members: string[] = [];

    followers: string[] = [];

    parent?: string | null; // organization Id

    groups: string[] = []; // Organization Ids means group Ids

    subType?: OrgSubType | null;

    moderator: any;

    address?: string;

    description?: string;

    constructor(_text: string, _moderator: any) {
      this.name = _text;
      this.moderator = _moderator;
    }

    static orgObject(org: any): Organization {
      const moderator = FirebaseUtil.ObjectToRef(COLLECTION_USERS, org.moderator.id);
      const orgObj = new Organization(org.name, moderator);
      const list = []as any;
      org.members.forEach((m: any) => {
        const mem = new Member();
        mem.id = m.id;
        mem.status = m.status;
        mem.role = FirebaseUtil.ObjectToRef(COLLECTION_ROLES, m.role.roleType.code);
        list.push({ ...mem });
      });
      orgObj.members = list;
      return orgObj;
    }
}
